import { render, staticRenderFns } from "./MapPreset.vue?vue&type=template&id=0ef303be&"
import script from "./MapPreset.vue?vue&type=script&lang=ts&"
export * from "./MapPreset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports